// extracted by mini-css-extract-plugin
export var carousel = "Carousel--carousel--PuhFu";
export var carousel__arrows = "Carousel--carousel__arrows--03YO9";
export var carousel__back = "Carousel--carousel__back--kI9Hf";
export var carousel__dotgroup = "Carousel--carousel__dotgroup--QHjty";
export var carousel__gap = "Carousel--carousel__gap--emo7Z";
export var carousel__glider_slide = "Carousel--carousel__glider_slide--YdH5u";
export var carousel__next = "Carousel--carousel__next--d3Li7";
export var gliderOverflow = "Carousel--gliderOverflow--cYwl1";
export var tkMyriadProSemiCondensed = "Carousel--tk-myriad-pro-semi-condensed--iRk8S";